import { Create, TextInput, SimpleForm, required, NumberInput, minValue } from 'react-admin';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import FileUpload from '../../common/inputs/FileUpload';
import { useSearchParams } from 'react-router-dom';
import TestimonialCategoryAutoComplete from './TestimonialCategoryAutoComplete';

const TestimonialCreate = () => {
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('categoryId');
    const isDisabled = !!categoryId;

    return (
        <Create redirect={'/testimonials'}>
            <SimpleForm>
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    source="authorImage"
                    label="Upload author image"
                    required={true}
                />
                <TextInput source="authorName" fullWidth validate={[required()]} />
                <NumberInput source="displayOrder" fullWidth validate={[required(), minValue(1)]} />
                <HTMLEditorInput
                    source="description"
                    fullWidth
                    validate={[required(), validHtml]}
                />
                <TestimonialCategoryAutoComplete
                    fullWidth
                    defaultValue={categoryId}
                    disabled={isDisabled}
                    validate={[required()]}
                />
            </SimpleForm>
        </Create>
    );
};

export default TestimonialCreate;
